import { Form, Input, InputNumber, Select } from "antd";
import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import style from "./style.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { MaterialService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import {
  useQueryMachineMaterialEnergySelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
} from "../../core/_hooks";
import { SimpleInput } from "../../../../common/components/simpleInput";
import { handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

type PropsType = {
  onFinish: () => void;
  initialValue?: any;
};
export const ChalandForm = ({ onFinish, initialValue }: PropsType) => {
  const [form] = Form.useForm();

  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryMachineMaterialStateSelect();
  const { data: energyOptions, isLoading: isLoadingEnergy } =
    useQueryMachineMaterialEnergySelect();
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,

        materialEnergy: initialValue?.materialEnergy
          ? {
              label: initialValue?.materialEnergy?.name,
              value: initialValue?.materialEnergy?.["@id"],
            }
          : null,
        materialFrom: initialValue?.materialFrom
          ? {
              label: initialValue?.materialFrom?.name,
              value: initialValue?.materialFrom?.["@id"],
            }
          : null,
        materialState: initialValue?.materialState
          ? {
              label: initialValue?.materialState?.name,
              value: initialValue?.materialState?.["@id"],
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        capacity: values?.capacity?.toString(),

        materialEnergy: values?.materialEnergy
          ? values?.materialEnergy?.value
          : null,
        materialFrom: values?.materialFrom ? values?.materialFrom?.value : null,
        materialState: values?.materialState
          ? values?.materialState?.value
          : null,
      };

      if (!dataToPost?.id) {
        const res = await MaterialService.createChalandMaterial(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await MaterialService.updateChalandMaterial(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Référence"
                name={"reference"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité (T)"
                name={"capacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputNumber min={0} className={style.form__input} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Etat"
                name={"materialState"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={stateOptions}
                    loading={isLoadingState}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Energie"
                name={"materialEnergy"}
                customInput={
                  <Select
                    labelInValue
                    options={energyOptions}
                    loading={isLoadingEnergy}
                  />
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Propriétaire"
                name={"materialFrom"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={fromOptions}
                    loading={isLoadingFrom}
                  />
                }
              />
            </div>
            <div className={style.form__item}></div>
          </div>
        </div>

        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
